import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';
import { useAppSelector } from '../../../../hooks';
import { StyledIdentityHeader } from '../Layout';
import AlertMessage from '../../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import { IUserInfo } from '../../types/ridpTypes';

const StyledDocumentListContainer = styled.div`
    .gi-alert {
        padding: 10px;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
        border-color: ${({ theme }) => theme.primaryMain};

        .usa-alert__text {
            h5 {
                font-weight: 400;
                font-size: 18px;
                margin-top: 5px;
                margin-bottom: 10px;
            }
        }
    }
`;

const StyledTable = styled.table`
    border: none;
    margin-top: 10px;
    font-size: 14px;
    width: 100%;
`;

const StyledHeaderContainer = styled.thead``;

const StyledHeaderRow = styled.tr``;

const StyledHeader = styled.th`
    background-color: ${({ theme }) => theme.gray9};
    color: ${({ theme }) => theme.gray3};
    padding: 8px;
    font-weight: 600;
`;
const StyledBody = styled.tbody`
    > tr:nth-child(odd) {
        background-color: ${({ theme }) => theme.gray11};
    }
    > tr:nth-child(even) {
        background-color: ${({ theme }) => theme.defaultWhite};
    }
`;

const StyledRow = styled.tr``;

const StyledColumn = styled.td<{ width?: number }>`
    width: ${({ width }) => width}%;
    padding: 8px;

    .gi-alert {
        padding: 5px;
        width: fit-content;
        border-radius: 2px;
        > div {
            padding-left: 0px !important;
            font-size: 12px;
        }
    }
    .doctype {
        font-size: 11px !important;
        color: ${({ theme }) => theme.gray5};
    }
`;

const UploadDocumentProcess = () => {
    const intl = useIntl();
    const currentUserInfo = useAppSelector(state => state.ridp.currentUserInfo) as IUserInfo;

    const documentData = useMemo(() => {
        return Array.isArray(currentUserInfo?.documentsUploaded) ? currentUserInfo.documentsUploaded : [];
    }, [currentUserInfo]);
    return (
        <div id="main-content">
            <StyledDocumentListContainer>
                <StyledIdentityHeader fontWeight={400}>
                    <FormattedMessage id={'ridp.manualverification.header'} />
                </StyledIdentityHeader>
                <AlertMessage
                    showIcon={false}
                    content={parse(
                        intl.formatMessage({ id: 'ridp.manualverification.uploaddocument.process.info' }),
                    )}
                    type="info"
                />
                <StyledTable>
                    <StyledHeaderContainer>
                        <StyledHeaderRow>
                            <StyledHeader>
                                <FormattedMessage id={'ridp.manualverification.document.label'} />
                            </StyledHeader>
                            <StyledHeader>
                                <FormattedMessage id={'ridp.manualverification.status.label'} />
                            </StyledHeader>
                            <StyledHeader>
                                <FormattedMessage id={'ridp.manualverification.notes.label'} />
                            </StyledHeader>
                        </StyledHeaderRow>
                    </StyledHeaderContainer>
                    <StyledBody>
                        {documentData.map((document, index) => (
                            <StyledRow key={index.toString()}>
                                <StyledColumn className="document-name" width={30}>
                                    {document?.documentType} <br />
                                    <span className="doctype">{document?.documentName}</span>
                                </StyledColumn>
                                <StyledColumn>
                                    {' '}
                                    <AlertMessage showIcon={false} content={document?.status} type="info" />
                                </StyledColumn>
                                <StyledColumn width={50}>{document?.comments}</StyledColumn>
                            </StyledRow>
                        ))}
                    </StyledBody>
                </StyledTable>
            </StyledDocumentListContainer>
        </div>
    );
};

export default UploadDocumentProcess;
